module.exports = __webpack_public_path__ + "img/roll-1372.706d0937.png";